import axios from 'axios';
import Globals from '../core/globals';

const axiosInstance = axios.create({
    baseURL: Globals.backendUri,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
